import React from "react";
import { Box, styled, Tooltip } from "@mui/material";
import { swatchBoxShadow } from "../../constants/swatchPalette";

const SwatchContainer = styled(Box)(
  ({ borderColor, isAccordionIcon, isSegmentColor }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: isAccordionIcon ? "24px" : isSegmentColor ? "34px" : "32px",
    height: isAccordionIcon ? "24px" : isSegmentColor ? "34px" : "32px",
    borderRadius: "50%",
    border: borderColor ? `1px solid ${borderColor}` : "none",
    cursor: "pointer",
  })
);

const SwatchColor = styled(Box)(({ color, isSegmentColor }) => ({
  width: isSegmentColor ? "30px" : "24px",
  height: isSegmentColor ? "30px" : "24px",
  borderRadius: "50%",
  background: color,
  // A white swatch would vanish on the white picker surface: it gets a 1px
  // neutral ring on top of the shared drop shadow (swatchPalette.js).
  boxShadow: swatchBoxShadow(color),
}));

const ColorSwatch = ({
  color,
  borderColor,
  isAccordionIcon = false,
  isSegmentColor = false,
}) => {
  return (
    <Tooltip title={color} placement="top" arrow>
      <SwatchContainer
        borderColor={borderColor}
        isAccordionIcon={isAccordionIcon}
        isSegmentColor={isSegmentColor}
      >
        <SwatchColor color={color} isSegmentColor={isSegmentColor} />
      </SwatchContainer>
    </Tooltip>
  );
};

export default ColorSwatch;
